<div class="log-scroll-container" (mouseleave)="isSecondaryLogButtonOpen = false">
	<div class="log-scroll-button-container">
		<div class="button" [ngClass]="{ 'double-button': userView !== userViewTypes.ENDUSER }" (click)="logModal.openModal()">
			{{ labels.lbl_incluir_acompanhamento }}
		</div>
		@if (userView !== userViewTypes.ENDUSER) {
			<div (click)="isSecondaryLogButtonOpen = !isSecondaryLogButtonOpen">
				<fa-icon [ngClass]="{ 'rotate-180': isSecondaryLogButtonOpen }" [icon]="icons.faAngleDown"></fa-icon>
			</div>
		}
	</div>
	@if (isSecondaryLogButtonOpen && userView !== userViewTypes.ENDUSER) {
		<div class="log-scroll-secondary-button-container">
			@for (status of availableStatus; track $index) {
				<span (click)="sendEmailEnduser = false; newLog.status = status.status; logModal.openModal()">
					{{ labels.lbl_atualizar_para }}: "{{ status.label }}"
				</span>
			}
		</div>
	}

	@if (!requestData.logs || requestData.logs.length === 0) {
		<div class="log">
			{{ labels.lbl_chamado_sem_logs }}
		</div>
	}
	@for (log of requestData.logs; track $index) {
		<div
			class="log"
			[ngClass]="{
				'super-user-edit': isSuperEditingLog,
				'super-user-edit-clickable': isSuperEditingLog,
				'super-selected': newSuperLog.idLog === log.idLog,
			}"
			(click)="isSuperEditingLog && newSuperLog.idLog !== log.idLog ? setNewSuperLog(log) : null">
			@if (newSuperLog.idLog === '' || newSuperLog.idLog !== log.idLog) {
				<span class="log-date"
					>{{ dateService.formatDate(log.log_date) }} -
					{{ allStatusAsLabel[log.status] ? allStatusAsLabel[log.status] : log.status }}</span
				>
				<span class="log-date">{{ log.analyst }}</span>
				@if (log.notes !== '' && log.duration !== '00:00' && !permissionService.hasPermission('REQUEST_hide_duration')) {
					<span class="log-date">{{ labels.lbl_geral_duracao }}: {{ formatDuration(log.duration) }}</span>
				}
				@for (file of log.file_log; track $index) {
					<span class="log-file" (click)="file.file_path !== '...' ? downloadFile(file.file_path) : null">
						<fa-icon class="mr-1" [icon]="icons.faDownload"></fa-icon> {{ formatAttachPath(file.file_path) }}
					</span>
				}
				<div class="log-notes">
					@if (getLogPrimaryNotes(log.notes)) {
						<div [innerHTML]="getLogPrimaryNotes(log.notes) | deNLize"></div>
					}
					@if (getLogInfoNote(log.notes)) {
						<cpi-info-alert [message]="getLogInfoNote(log.notes) | deNLize" [compact]="true" [useHtml]="true"> </cpi-info-alert>
					}
				</div>
			}

			@if (newSuperLog.idLog === log.idLog) {
				<span class="log-date mb-2">
					<input
						type="date"
						[value]="formatDateToValue(log.log_date)"
						(change)="newSuperLog.log_date = $any($event.target).value" />
				</span>
				<span class="log-date mb-2">
					<select (change)="newSuperLog.status = $any($event.target).value">
						@for (status of availableStatus; track $index) {
							<option [value]="status.status" [selected]="newSuperLog.status === status.status">
								{{ status.label }}
							</option>
						}
					</select>
				</span>
				<span class="log-date mb-2"
					><input
						type="text"
						[placeholder]="labels.lbl_analista"
						(input)="newSuperLog.analyst = $any($event.target).value"
						[value]="log.analyst"
				/></span>
				<span class="log-date mb-2"
					><input
						type="text"
						matInput
						mask="Hh:m0"
						(input)="newSuperLog.duration = $any($event.target).value"
						[value]="formatDuration(log.duration)"
				/></span>
				<span class="log-notes">
					<textarea rows="3" (input)="newSuperLog.notes = $any($event.target).value" [value]="log.notes | deNLize"></textarea>
				</span>

				<div class="button-container">
					<div class="button" (click)="resetSuperLog(); isSuperEditingLog = false">{{ labels.lbl_geral_cancelar }}</div>
					<div class="button" (click)="superUpdateLog(log.idLog)">{{ labels.lbl_geral_atualizar }}</div>
				</div>
			}
		</div>
	}
</div>

<cpi-modal
	[title]="labels.lbl_adicionar_nova_log"
	[showFooter]="true"
	(onModalClose)="logModal.closeModal()"
	(fullscreenChange)="isModalExpanded = $event"
	#logModal>
	<ng-container body>
		<div class="textarea-wrapper" [class.expanded]="isModalExpanded">
			<textarea
				[placeholder]="labels.lbl_escreva_informacoes_log"
				[rows]="3"
				[value]="newLog.notes"
				(input)="newLog.notes = $any($event.target).value"></textarea>
		</div>

		@if (userView === userViewTypes.ANALYST) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_status }}</span>
				@if (!isLoadingAvailableStatus) {
					<select (change)="newLog.status = $any($event.target).value">
						<option value="" disabled [selected]="!newLog.status">{{ labels.lbl_geral_selecione }}</option>
						@for (status of availableStatus; track $index) {
							<option [value]="status.status" [selected]="status.status === newLog.status || status.status === ''">
								{{ status.label }}
							</option>
						}
					</select>
				}
				@if (isLoadingAvailableStatus) {
					<cpi-dot-bounce-loading-effect [color]="'var(--gray-5)'"></cpi-dot-bounce-loading-effect>
				}
			</div>
		}

		@if (newLog.status === 'Waiting User' && userView === userViewTypes.ANALYST && enable3strikes > 1) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_aplicar_strike }}</span>
				<cpi-checkbox
					[value]="applyStrike"
					(oValue)="applyStrike = $event"
					[innerText]="applyStrike ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>
		}

		@if (newLog.status === 'Solved' && userView === userViewTypes.ANALYST && requestDataMemory.child_requests?.length > 0) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_encerrar_tambem_chamados_filho }}</span>
				<cpi-checkbox
					[value]="closeChildRequests"
					(oValue)="closeChildRequests = $event"
					[innerText]="closeChildRequests ? labels.lbl_geral_sim : labels.lbl_geral_nao">
				</cpi-checkbox>
			</div>
		}

		@if (newLog.status !== 'Internal Comment') {
			<div>
				<div class="dotted-input-container">
					<span>{{ userView === userViewTypes.ANALYST ? labels.lbl_chamado_enviar_email_solicitante : 'Enviar e-mail' }}</span>
					<cpi-checkbox
						[value]="sendEmailEnduser"
						(oValue)="sendEmailEnduser = $event"
						[innerText]="sendEmailEnduser ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>
			</div>
		}

		@if (newLog.status !== 'Internal Comment' && sendEmailEnduser) {
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_notificar_email_copia }}:</span>
				<input
					type="text"
					[value]="selectedEmailCCUserIAC.name"
					placeholder="Digite um ou mais e-mails separados por , ou ;"
					(input)="selectedEmailCCUserIAC.name = $any($event.target).value; selectedEmailCCUserIAC.value = ''" />
			</div>
		}

		@if (newLog.status !== 'Internal Comment' && userView === userViewTypes.ANALYST) {
			<div>
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_anexo_enduser }}</span>
					<cpi-checkbox
						[value]="newLog.sendEmailAttachEnduser"
						(oValue)="newLog.sendEmailAttachEnduser = $event"
						[innerText]="newLog.sendEmailAttachEnduser ? labels.lbl_geral_sim : labels.lbl_geral_nao">
					</cpi-checkbox>
				</div>
			</div>
		}

		@if (userView === userViewTypes.ANALYST) {
			<div class="dotted-input-container">
				<div>
					<span>{{ labels.lbl_geral_duracao }}</span>
					<span [title]="labels.lbl_request_duration_tip"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
				</div>
				<div class="input-timer-container">
					<fa-icon [icon]="currentTimerIcon"></fa-icon>
					<input
						class="input-timer"
						mask="00:00"
						[placeholder]="newLog.duration"
						[value]="newLog.duration"
						(input)="newLog.duration = $any($event.target).value"
						(blur)="formatTimer()"
						[disabled]="startTimer === true" />
					<div class="button" (click)="countRequestDuration(newLog.duration)">
						{{ startTimer ? labels.lbl_geral_parar_cont : labels.lbl_geral_iniciar_cont }}
					</div>
				</div>
			</div>
		}

		@if (
			newLog.status === 'Solved' && requestData.service_type === 'Incident' && isLimitDateOver() && userView === userViewTypes.ANALYST
		) {
			<div class="label">{{ labels.lbl_geral_conformidade }}:</div>
			<textarea
				class="mt-1"
				[placeholder]="labels.lbl_motivo_atraso"
				[rows]="3"
				[value]="newLog.overdueReason"
				(input)="newLog.overdueReason = $any($event.target).value">
			</textarea>
		}

		<div class="dotted-input-container">
			<div>
				{{ labels.lbl_geral_anexar_arquivo }}
				<span [title]="allowedMimeTypeTip"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
			</div>
			<div>
				<label class="button" for="logFile">{{ labels.lbl_geral_anexar_arquivo }}</label>
				<input type="file" id="logFile" #logFile (change)="handleFileLog()" [multiple]="true" [accept]="allowedMimeTypeStr" />
			</div>
		</div>

		@if (newLog.file_log.length > 0) {
			<div class="label" *ngIf="">{{ labels.lbl_geral_anexo }}</div>
		}
		<div class="file-container">
			@for (file of newLog.file_log; let index = $index; track file) {
				<div class="dotted-input-container">
					<span>{{ file.name }}.{{ file.extension }}</span>
					<span (click)="handleFileLog(index)">
						<fa-icon [icon]="icons.faTrash"></fa-icon>
					</span>
				</div>
			}
		</div>
	</ng-container>

	<ng-container footer>
		<div class="button-container">
			<button (click)="logModal.closeModal()">{{ labels.lbl_geral_fechar }}</button>
			<msp-button [disabled]="isSendingLog" [loading]="isSendingLog" (click)="addLog()">{{ labels.lbl_geral_enviar }}</msp-button>
		</div>
	</ng-container>
</cpi-modal>
